import React from 'react';
import { Navigate } from 'react-router-dom';
import { useIsAuthenticated } from '@azure/msal-react';

const ProtectedRoute = ({ children }) => {
    const isAuthenticated = useIsAuthenticated();
    if (isAuthenticated === undefined) return <div>Loading...</div>;
    return isAuthenticated ? children : <Navigate to="/" replace />;
};

export default ProtectedRoute;